export const SAVED_FILTER_NAME_MAX_LENGTH = 60;

export type SavedFilterNameValidationError = 'duplicate' | 'tooLong';

export const validateSavedFilterName = ({
  name,
  isDuplicate,
}: {
  name: string;
  isDuplicate: boolean;
}): SavedFilterNameValidationError | null => {
  if (name.length > SAVED_FILTER_NAME_MAX_LENGTH) {
    return 'tooLong';
  }

  if (isDuplicate) {
    return 'duplicate';
  }

  return null;
};
